import { useState, useEffect, useCallback } from 'react';

export function useYearlyExpenses(storage, year) {
  const [expenses, setExpenses] = useState([]);
  const [loading, setLoading] = useState(true);

  const refresh = useCallback(async () => {
    setLoading(true);
    const data = await storage.getExpensesForYear(year);
    setExpenses(data);
    setLoading(false);
  }, [storage, year]);

  useEffect(() => {
    refresh();
  }, [refresh]);

  return { expenses, loading, refresh };
}
